import { ReactNode } from "react";
import { Divider, List } from "@chakra-ui/react";
import SideBarHeading from "components/Layout/SideBar/Heading";

type Props = { children: ReactNode; isFirst?: boolean; heading?: ReactNode };

export default function SideBarSection({ children, isFirst, heading }: Props) {
  return (
    <>
      {!isFirst && <Divider my={4} borderColor="gray.300" />}
      {heading && <SideBarHeading isFirst={isFirst}>{heading}</SideBarHeading>}
      <List>{children}</List>
    </>
  );
}
